<script lang="ts" setup>
    import '../../../css/choice.css';
    import { ModalWindowOpen } from '../../lib/ChoiceUserConfiguration';
    import {AppScreens} from '../../Enums/ChoiceEnums';
    import {onMounted,watch,computed,reactive,ref} from 'vue';  
    import {popAlert,ModalStyles} from '../../lib/Notification';   
    import ActionFoldingPanel from "../../components/ActionFoldingPanel.vue";  
    import ClaimList from '../Billing/Subcomponents/ClaimList.vue'; 
    import ActionButtonV2 from '../../components/ActionButtonV2.vue'; 
    import {ButtonDisplaySize,ButtonDisplayStyle,LayoutOrientation,ModalSize,DropDownButtonIconType} from '../../Enums/UiEnums'; 
    import {ErrorReturnMessage,getPayPlanDetails,updatePaymentPlanStatus,updatePaymentPlan,
            updatePaymentPlanClaims,deferPaymentPlan,changeRP,updatePaymentPlanCreditCard} from '../../lib/Api/PaymentPlan';
    import {getCompanySettingNumber,getCompanySetting} from '../../lib/Api/Claim';
    import {IPaymentPlanStatusUpdate,IPaymentPlanUpdate,IPaymentPlanDetail,IPaymentPlanInstallment,UpdateTitleBar,
            IDeferDate,IDeferPlan,PlanStatus,InstallmentType,IPaymentPlanClaimUpdates,IPaymentPlanDeferments,
            IPaymentClaimInformation,IRespPartyUpdate,IPaymentPlanCardUpdate,PlanMaximumAmount,PlanSettingItem,RecurringClassLabel} from '../../lib/Models/PaymentPlanModel';  
    import {IClaim,ClaimDisplay,ClaimTableWidth,ClaimColumnDefinitions,ClaimSelectionType,ClaimSimpleLists} from '../../lib/Models/ClaimModel';   
    import {prettyCurrency} from '../../lib/Formatting/Number'; 
    import Checkbox from '../../components/Inputs/Checkbox.vue';
    import TextInput from '../../components/TextInput.vue'; 
    import SimpleList from '../../components/SimpleList.vue';
    import IntegerInput from '../../components/IntegerInput.vue';
    import CurrencyInput from '../../components/CurrencyInput.vue';
    import RadioButtonInput from '../../components/RadioButtonInput.vue'; 
    import ModalDialog from "../../components/ModalDialog.vue";
    import DropDownButton from "../../components/DropDownButton.vue";
    import DropDownButtonItem from "../../components/DropDownButtonItem.vue";
    import Validator from '../../components/Validator.vue'; 
    import PaymentPlanCreditCard from '../Billing/PaymentPlanCreditCard.vue';
    import PaymentPlanPrint from '../Billing/PaymentPlanPrint.vue';  
    import {initPinia} from '../../lib/PiniaMgr';
    import {usePaymentPlanDetailsStore} from '../../lib/Stores/PaymentPlanDetailsStore';
    import {useSimpleListStore} from '../../lib/Stores/SimpleListStore'; 
    import {IActionButtons,ActionButtonStyle} from '../../lib/Types/Types';  
  
    const actionButtonWidth = 130;
    const paymentPlanDetailsStore = usePaymentPlanDetailsStore(initPinia());
    const simpleListStore = useSimpleListStore(initPinia());
    const claimPatientBaseMessage = "Patient Balance Claims";
    const claimIncludedBaseMessage = "Included Payment Plan Balance Claims";
    const selectClaim = true;
    const planDetailsWidth = ClaimTableWidth + ClaimColumnDefinitions.Payer +  ClaimColumnDefinitions.Status + (25/16); 
    
    enum PageActions{
        Audit,
        CompanySettings,
        Refresh 
    } 
    enum DetailActionButtons {
        PrintPlan = 0,
        UpdatePlan = 1,
        UpdateStatus = 2,
        ChangeResponsibleParty = 3,
        Defer = 4,
        AddCard = 5,
    }
    enum StatusClass {
        Active = "text-success fw-bold",
        Completed = "text-black fw-bold",
        PastDue = "text-danger fw-bold",
        Hold = "text-warning fw-bold",
        Cancelled = "text-secondary fw-bold",
    }
    
    const includedClaimButtons = ref<IActionButtons>(
        [
            {baseText: 'Remove Claim', disabled: true, clickEvent: removeClaim, toolTip: 'Remove selected claims', width: actionButtonWidth, spinText: "Removing", overRideStyle:ActionButtonStyle.Remove}
        ] 
    );   
    const patientClaimButtons = ref<IActionButtons>(
        [
            {baseText: 'Add Claim', disabled: true, clickEvent: addClaim, toolTip: 'Add selected claims', width: actionButtonWidth, spinText: "Adding", overRideStyle:ActionButtonStyle.Add}
        ] 
    );    
    const detailButtons = ref<IActionButtons>(
        [
            {baseText: 'Print Plan', disabled: true, clickEvent: printPlan, toolTip: 'Print Plan Details', width: actionButtonWidth, spinText: "Printing", overRideStyle:ActionButtonStyle.Print},
            {baseText: 'Update Plan', disabled: true, clickEvent: updatePlan, toolTip: 'Update Plan Details', width: actionButtonWidth, spinText: "Updating", overRideStyle:ActionButtonStyle.Edit},
            {baseText: 'Update Status', disabled: true, clickEvent: updateStatus, toolTip: 'Update Status', width: actionButtonWidth, spinText: "Updating", overRideStyle:ActionButtonStyle.Edit},
            {baseText: 'Resp. Party', disabled: true, clickEvent: changeResponsibleParty, toolTip: 'Change Responsible Party', width: actionButtonWidth, spinText: "Changing", overRideStyle:ActionButtonStyle.Edit},
            {baseText: 'Deferment', disabled: true, clickEvent: deferPayment, toolTip: 'Defer Payment', width: actionButtonWidth, spinText: "Deferring", overRideStyle:ActionButtonStyle.DeferPayment},
            {baseText: 'Add Card', disabled: true, clickEvent: addCreditCard, toolTip: 'Add Credit Card', width: actionButtonWidth, spinText: "Adding", overRideStyle:ActionButtonStyle.CreditCard},
        ] 
    ); 
    const respPartyListLoaded = computed<boolean>(()=> {
        if (!simpleListStore) {
            return false;
        } 
        if (!simpleListStore.listResult[ClaimSimpleLists.RespParty]) {
            return false;
        } 
        return true;
    });   
    const validateSection = ref();  
    const formData = reactive <
    {      
        planDetails?: IPaymentPlanDetail,
        planDeferments?: IPaymentPlanDeferments[],
        payments?: IPaymentPlanInstallment[],
        planClaims?: IClaim[],
        patientClaims?: IClaim[],
        paymentPlanUpdate: IPaymentPlanUpdate,
        paymentPlanStatusUpdate: IPaymentPlanStatusUpdate,
        includedClaimInformation: {total: number, message : string},
        patientClaimInformation: {total: number, message : string},
        selectedPatientClaims?: IClaim[],
        selectedIncludedClaims?: IClaim[],
        claimAddRemoveData: IPaymentClaimInformation,
        modelDisplay : {updatePlan: boolean, updateStatus: boolean, defer: boolean, addClaim: boolean, removeClaim: boolean, changeRespParty: boolean, addCard: boolean, printPaymentPlan: boolean},
        planSettings: {MinimumAmt: number, MaximumAmt: number, MinimumCnt: number, MaximumCnt: number, LastPaymentMin: number, Recurring: string},
        disableStatus: {Active: boolean, Cancelled: boolean, Completed: boolean, Hold: boolean, PastDue: boolean},
        defermentList?: IDeferDate[],
        planUpdatesAreValid: boolean,
        priorValues: {installmentAmount: number, totalInstallments: number},
        defermentPlan? : IDeferPlan,
        responsiblePartyEID? : number,
        cardUpdate: IPaymentPlanCardUpdate,
        cardToolTip: string,
        refreshCards: number
    }>({     
        includedClaimInformation: {total: 0, message : claimIncludedBaseMessage},
        patientClaimInformation: {total: 0, message : claimPatientBaseMessage},
        modelDisplay : { updatePlan: false, updateStatus: false, defer: false, addClaim: false, removeClaim: false, changeRespParty: false, addCard: false, printPaymentPlan: false},
        paymentPlanUpdate: {paymentPlanId: 0, totalAmount: 0, writeOffAdjustmentAmount: 0, installmentAmount: 0, totalInstallments: 0, recurringPayments: false, doNotSendStatement: false, excludeClaimStatements: false},
        planSettings: {MinimumAmt: 0, MaximumAmt: 0, MinimumCnt: 0, MaximumCnt: 0, LastPaymentMin: 5, Recurring: "true"},
        paymentPlanStatusUpdate: {paymentPlanId: 0, statusID: PlanStatus.Cancelled, removeClaims: true},
        disableStatus: {Active: true, Cancelled: true, Completed: true, Hold: true, PastDue: true},
        claimAddRemoveData: {addClaim: false, canAdjustTotal: false, adjustTotal: false, adjustmentAmount: 0, claimList: ""}, 
        planUpdatesAreValid: true, 
        priorValues: {installmentAmount: 0, totalInstallments: 0},
        cardUpdate: {paymentPlanId: 0},
        cardToolTip: "",
        refreshCards: 0
    });
    const props = withDefaults(defineProps<{ 
        saveEnabled: number,
        paymentPlanId: number,
        refreshCards: number
    }>(),
    {
        saveEnabled: 0,
        paymentPlanId: 0,
        refreshCards: 0
    });

    onMounted(async () => {   
        refreshData();
    });
    watch(() => props.refreshCards, (newID, oldID) => {
        if ((newID !== oldID) && (newID > 0))  {
            formData.refreshCards = newID;
        }
    });
    const planAbsoluteMaximum = computed<number>(() => {
        if (formData.planSettings.MaximumAmt > 0) {
            return formData.planSettings.MaximumAmt
        }
        return PlanMaximumAmount;
    });
    const recurringDisabled = computed<boolean>(()=>  { 
        if (!formData.cardUpdate.paymentMethodID) {
            return true;
        }
        if (formData.planSettings.Recurring === 'true') {
            return false;
        }
        return true;
    });
    const recurringClass = computed<string>(()=>  { 
        if (!formData.cardUpdate.paymentMethodID) {
            return RecurringClassLabel.Disabled
        }
        if (recurringDisabled.value) {
            return RecurringClassLabel.Disabled
        }
        return RecurringClassLabel.Enabled
    });
    const statusDisplayClass = computed<StatusClass>(() => {
        if (!formData.planDetails) {
            return StatusClass.Cancelled;
        }
        
        switch (formData.planDetails.statusID) {
                case PlanStatus.Active:
                    return StatusClass.Active;
                case PlanStatus.Completed:
                    return StatusClass.Completed;
                case PlanStatus.PastDue:
                    return StatusClass.PastDue;
                case PlanStatus.Hold:
                    return StatusClass.Hold;
                case PlanStatus.Cancelled:
                    return StatusClass.Cancelled;
        }
        return StatusClass.Cancelled;
    });
    const displayModalWindow = computed<boolean>(()=>  {
        if (formData.modelDisplay.updatePlan) {
            return true;
        }
        if (formData.modelDisplay.updateStatus) {
            return true;
        }
        if (formData.modelDisplay.defer) {
            return true;
        }
        if (formData.modelDisplay.addClaim) {
            return true;
        }
        if (formData.modelDisplay.removeClaim) {
            return true;
        }
        if (formData.modelDisplay.changeRespParty) {
            return true;
        }
        return false;
    });
    
    const displayModalSize = computed<ModalSize>(()=>  {
        if (formData.modelDisplay.addClaim) {
            return ModalSize.Medium;
        }
        if (formData.modelDisplay.removeClaim) {
            return ModalSize.Medium;
        }
        if (formData.modelDisplay.changeRespParty) {
            return ModalSize.Medium;
        }
        return ModalSize.Small;
    });    
    const maximumInstallments = computed<number>(()=>  {
        if (formData.planDetails?.installmentType == InstallmentType.Monthly) {
            return formData.planSettings.MaximumCnt;
        }
        else if (formData.planDetails?.installmentType == InstallmentType.BiWeekly) {
            return Math.ceil(formData.planSettings.MaximumCnt * 2.17); // There are 2.17 biweeks (sp?) per month.
        }
        return Math.ceil(formData.planSettings.MaximumCnt * 4.3); // There are 4.3 weeks per month.
    });    
    async function refreshData() : Promise<void>  {
        resetReactiveValues();

        const [minimumAmt,maximumAmt,minimumCnt,maximumCnt,recurring,lastPaymentMin] = 
            await Promise.all([
                getCompanySettingNumber("PPLAN", PlanSettingItem.MinPlanAmount),
                getCompanySettingNumber("PPLAN", PlanSettingItem.MaxPlanAmount),
                getCompanySettingNumber("PPLAN", PlanSettingItem.MinInstallmentMonths),
                getCompanySettingNumber("PPLAN", PlanSettingItem.MaxInstallmentMonths),
                getCompanySetting("PPLAN", PlanSettingItem.RecurringPayments),
                getCompanySettingNumber("PPLAN", PlanSettingItem.LastPaymentMin)
            ]);  

        formData.planSettings.MinimumAmt = minimumAmt;
        formData.planSettings.MaximumAmt = maximumAmt;
        formData.planSettings.MinimumCnt = minimumCnt;
        formData.planSettings.MaximumCnt = maximumCnt;
        formData.planSettings.Recurring = recurring;
        formData.planSettings.LastPaymentMin =  lastPaymentMin; 

        paymentPlanDetailsStore.resetPaidClaims();
        paymentPlanDetailsStore.resetIncludedClaims();
        paymentPlanDetailsStore.resetPatientClaims();
        const respGet = await getPayPlanDetails(props.paymentPlanId); 
        if (!respGet.success) {  
            await popAlert(respGet.error?.error ?? ErrorReturnMessage.details,"Payment Plan Details",ModalStyles.danger);
            return;
        } 
        if (respGet.success.paidClaims) {
            if ((respGet.success.paidClaims?.length ?? 0) > 0) {  
                paymentPlanDetailsStore.loadPaidClaims(respGet.success.paidClaims);
            }
            else {
                paymentPlanDetailsStore.resetPaidClaims();
            }
        }
        formData.responsiblePartyEID = respGet.success.planDetail.responsiblePartyEID;
        formData.planDetails = respGet.success.planDetail; 
        formData.payments = respGet.success.installmentListing;
        formData.patientClaims = respGet.success.patientClaims;
        formData.planClaims = respGet.success.planClaims;
        formData.cardUpdate = {paymentPlanId: props.paymentPlanId,paymentMethodID: formData.planDetails.paymentMethodID, creditCard: formData.planDetails.creditCard};
        formData.planDeferments = respGet.success.deferments; 
        formData.cardToolTip = `Card on file: ${(formData.cardUpdate.paymentMethodID ?? 0 > 0 ? formData.cardUpdate.creditCard : "None")}`;
        UpdateTitleBar(formData.planDetails.patientID,formData.planDetails.patientName ?? "",formData.planDetails.patientDOB ?? "",formData.planDetails.patientRHC ?? "");
        setActionButtons();
        const where_clause = "patient_id^" + formData.planDetails.patientID.toString();
        await simpleListStore.getSimpleWhereList(ClaimSimpleLists.RespParty,where_clause); 
        await simpleListStore.getSimpleWhereList(ClaimSimpleLists.CreditCard,where_clause);  
    }
    function resetReactiveValues() : void {
        formData.payments = [];
        formData.planClaims = [];
        formData.patientClaims = [];
        formData.selectedPatientClaims = [];
        formData.selectedIncludedClaims = [];
        formData.defermentList = [];
        formData.includedClaimInformation = {total: 0, message : claimIncludedBaseMessage};
        formData.patientClaimInformation ={total: 0, message : claimPatientBaseMessage};
        formData.modelDisplay = { updatePlan: false, updateStatus: false, defer: false, addClaim: false, removeClaim: false, changeRespParty: false, addCard: false, printPaymentPlan: false};
        formData.paymentPlanUpdate = {paymentPlanId: 0, totalAmount: 0, writeOffAdjustmentAmount: 0, installmentAmount: 0, totalInstallments: 0, recurringPayments: false, doNotSendStatement: false, excludeClaimStatements: false};
        formData.disableStatus =  {Active: true, Cancelled: true, Completed: true, Hold: true, PastDue: true};
        formData.paymentPlanStatusUpdate = {paymentPlanId: props.paymentPlanId, statusID: PlanStatus.Cancelled, removeClaims: true};
        formData.planUpdatesAreValid = true;
        formData.priorValues =  {installmentAmount: 0, totalInstallments: 0};
        formData.claimAddRemoveData = {addClaim: false, canAdjustTotal: false, adjustTotal: false, adjustmentAmount: 0, claimList: ""};
        formData.defermentPlan = {paymentPlanId: props.paymentPlanId, deferDate: "", numberOfPeriods: 0};
    }
    function setActionButtons() : void {
        if ((!props.saveEnabled) || (!formData.planDetails)) {
            disableActionAll(true);
            return;
        }        
        detailButtons.value[DetailActionButtons.PrintPlan].disabled = false;
        if (formData.planDetails.patientRHC) {
            disableActionAll(true);
            detailButtons.value[DetailActionButtons.UpdateStatus].disabled = false;
            return;
        }
        if (formData.planDetails.statusID === PlanStatus.Completed) {
            disableActionAll(true);
            return;
        }
        if (formData.planDetails.statusID === PlanStatus.Cancelled) {
            disableActionAll(true);
            detailButtons.value[DetailActionButtons.UpdateStatus].disabled = false;
            return;
        }
        disableActionAll(false);
    }; 
    function disableActionAll(disabled : boolean) {
        const included_claim_count = formData.selectedIncludedClaims?.length ?? 0;
        const patient_claim_count = formData.selectedPatientClaims?.length ?? 0;
         
        includedClaimButtons.value[0].disabled = (disabled ? true : (included_claim_count == 0));
        patientClaimButtons.value[0].disabled = (disabled ? true : (patient_claim_count == 0)); 
        detailButtons.value[DetailActionButtons.AddCard].disabled = disabled;
        detailButtons.value[DetailActionButtons.UpdatePlan].disabled = disabled;
        detailButtons.value[DetailActionButtons.UpdateStatus].disabled = disabled;
        detailButtons.value[DetailActionButtons.Defer].disabled = disabled;
        detailButtons.value[DetailActionButtons.ChangeResponsibleParty].disabled = disabled;
    } 
    function setIncludedClaims (itemList : any) : void {
        formData.selectedIncludedClaims = itemList.map((item: string | number) => ({claimID: +item})); 
        formData.includedClaimInformation.total = paymentPlanDetailsStore.getTotalBalanceSelected(ClaimSelectionType.Included);
        updateIncludedClaimMessaging();
        setActionButtons();
    } 
    function updateIncludedClaimMessaging() : void {
        const included_total = paymentPlanDetailsStore.getTotalBalance(ClaimSelectionType.Included);
        formData.includedClaimInformation.message = `${claimIncludedBaseMessage} - ${prettyCurrency(formData.includedClaimInformation.total)}/${prettyCurrency(included_total)}`;
    }
    function setPatientClaims (itemList : any) : void { 
        formData.selectedPatientClaims = itemList.map((item: string | number) => ({claimID: +item})); 
        formData.patientClaimInformation.total = paymentPlanDetailsStore.getTotalBalanceSelected(ClaimSelectionType.Patient);
        updatePatientClaimMessaging();
        setActionButtons();
    } 
    function updatePatientClaimMessaging() : void {
        const patient_total = paymentPlanDetailsStore.getTotalBalance(ClaimSelectionType.Patient);
        formData.patientClaimInformation.message = `${claimPatientBaseMessage} - ${prettyCurrency(formData.patientClaimInformation.total)}/${prettyCurrency(patient_total)}`;
    }
    function removeClaim() : void {
        includedClaimButtons.value[0].executing = true;
        if (formData.selectedIncludedClaims) {
            const can_adjust_total = (formData.includedClaimInformation.total <= (formData.planDetails?.totalAmount ?? 0)); 
            const adjustment_amount = (can_adjust_total ?  formData.includedClaimInformation.total : 0);
             
            formData.modelDisplay.removeClaim = true; 
            formData.claimAddRemoveData = {addClaim: false, canAdjustTotal: can_adjust_total, adjustTotal: can_adjust_total, adjustmentAmount: adjustment_amount, claimList: formData.selectedIncludedClaims.map(item => item.claimID).join(", ")};
        }
        setTimeout(() => {
            includedClaimButtons.value[0].executing = false;
        },150);

    }
    function addClaim() : void { 
        patientClaimButtons.value[0].executing = true;
        if (formData.selectedPatientClaims) {
            formData.modelDisplay.addClaim = true; 
            formData.claimAddRemoveData = {addClaim: true, canAdjustTotal: true, adjustTotal: true, adjustmentAmount: formData.patientClaimInformation.total, claimList: formData.selectedPatientClaims.map(item => item.claimID).join(", ")};
        }
        setTimeout(() => {
            patientClaimButtons.value[0].executing = false;
        },150);
    }
    function printPlan() : void {
        detailButtons.value[DetailActionButtons.PrintPlan].executing = true;
        formData.modelDisplay.printPaymentPlan = true;
        setTimeout(() => {
            detailButtons.value[DetailActionButtons.PrintPlan].executing = false;
        },150);
    }
    function changeResponsibleParty() : void {
        detailButtons.value[DetailActionButtons.ChangeResponsibleParty].executing = true;
        formData.modelDisplay.changeRespParty = true; 
        setTimeout(() => {
            detailButtons.value[DetailActionButtons.ChangeResponsibleParty].executing = false;
        },150);
    }
    function updatePlan() : void {
        detailButtons.value[DetailActionButtons.UpdatePlan].executing = true;
        if (formData.planDetails) {
            formData.paymentPlanUpdate.paymentPlanId = props.paymentPlanId;
            formData.paymentPlanUpdate.totalAmount = formData.planDetails.totalAmount;
            formData.paymentPlanUpdate.writeOffAdjustmentAmount = formData.planDetails.writeOffAdjustmentAmount;
            formData.paymentPlanUpdate.installmentAmount = formData.planDetails.installmentAmount;
            formData.paymentPlanUpdate.totalInstallments = formData.planDetails.totalInstallments;
            formData.paymentPlanUpdate.comment = formData.planDetails.comment;
            formData.paymentPlanUpdate.recurringPayments = formData.planDetails.recurringPayments;
            formData.paymentPlanUpdate.excludeClaimStatements = formData.planDetails.excludeClaimStatements;
            formData.paymentPlanUpdate.doNotSendStatement = formData.planDetails.doNotSendStatement;
            SetPriorValues();
            formData.modelDisplay.updatePlan = true; 
        }
        setTimeout(() => {
            detailButtons.value[DetailActionButtons.UpdatePlan].executing = false;
        },150);
    }
    function SetPriorValues() : void {
        formData.priorValues.installmentAmount = formData.paymentPlanUpdate.installmentAmount;
        formData.priorValues.totalInstallments = formData.paymentPlanUpdate.totalInstallments;
    }
    function addCreditCard() : void {
        detailButtons.value[DetailActionButtons.AddCard].executing = true;
        formData.modelDisplay.addCard = true;
        setTimeout(() => {
            detailButtons.value[DetailActionButtons.AddCard].executing = false;
        },150);
    }
    function updateStatus() : void {
        detailButtons.value[DetailActionButtons.UpdateStatus].executing = true; 
        if (formData.planDetails) {
            formData.paymentPlanStatusUpdate.paymentPlanId = props.paymentPlanId;
            switch (formData.planDetails.statusID) {
                case PlanStatus.Active:
                    formData.paymentPlanStatusUpdate.statusID = PlanStatus.Cancelled;
                    formData.disableStatus = {Active: true, Cancelled: false, Completed: true, Hold: false, PastDue: true};
                    break;
                case PlanStatus.PastDue:
                    formData.paymentPlanStatusUpdate.statusID = PlanStatus.Cancelled;
                    formData.disableStatus = {Active: false, Cancelled: false, Completed: true, Hold: false, PastDue: true};
                    break;
                case PlanStatus.Hold:
                    formData.paymentPlanStatusUpdate.statusID = PlanStatus.Cancelled;
                    formData.disableStatus = {Active: false, Cancelled: false, Completed: true, Hold: true, PastDue: true};
                    break;
                case PlanStatus.Cancelled:
                    formData.paymentPlanStatusUpdate.statusID = PlanStatus.Active;
                    formData.disableStatus = {Active: false, Cancelled: true, Completed: true, Hold: false, PastDue: true};
                    break;
                case PlanStatus.Completed:
                    formData.paymentPlanStatusUpdate.statusID = PlanStatus.Completed;
                    formData.disableStatus = {Active: true, Cancelled: true, Completed: true, Hold: true, PastDue: true};
                    break; 
            }
            formData.modelDisplay.updateStatus = true; 
        } 
        setTimeout(() => {
            detailButtons.value[DetailActionButtons.UpdateStatus].executing = false;
        },150);
    }
    function deferPayment() : void {
        detailButtons.value[DetailActionButtons.Defer].executing = true; 
        buildDefermentList();
        
        formData.modelDisplay.defer = true; 
        setTimeout(() => {
            detailButtons.value[DetailActionButtons.Defer].executing = false;
        },150);
    } 
    function buildDefermentList() : void {
        formData.defermentList = [];

        if (!formData.planDetails) {
            return;
        }
        let end_date = new Date();
        if (formData.payments) {
            const last_item = formData.payments.length - 1;
            if (last_item > -1) {
                end_date = new Date(formData.payments[last_item].dueDate);
            }
            if (last_item + 1 > 0) {
                formData.defermentList = formData.payments.filter(item => item.installmentAmount - (item.paymentAmount ?? 0) >= 0).map(item => ({deferDate: item.dueDate}));
            }
        }
        if (formData.defermentList) {
            formData.defermentPlan = {paymentPlanId: props.paymentPlanId, deferDate: formData.defermentList[0].deferDate, numberOfPeriods: 0};
        }
    }
    async function ModalHiddenResponse() : Promise<void> {
        formData.modelDisplay.updatePlan = false;
        formData.modelDisplay.updateStatus = false;
        formData.modelDisplay.defer = false; 
        formData.modelDisplay.addClaim = false; 
        formData.modelDisplay.removeClaim = false; 
        formData.modelDisplay.changeRespParty = false;
        formData.planUpdatesAreValid = true;
    }
    async function execUpdatePlan() : Promise<boolean> {
        const returnResults = await updatePaymentPlan(formData.paymentPlanUpdate);
        const messageTitle = "Update Payment Plan";
        if (!returnResults.success) {  
            popAlert(returnResults.error?.error ?? ErrorReturnMessage.updateStatus,messageTitle,ModalStyles.danger);
            return false;
        } 
        if (returnResults.success.errorCode !== 0) { 
            popAlert(returnResults.success.errorMessage,messageTitle,ModalStyles.danger); 
            return false;
        }
        return true; 
    }
    async function execUpdatePlanStatus() : Promise<boolean> {
        const returnResults = await updatePaymentPlanStatus(formData.paymentPlanStatusUpdate);
        const messageTitle = "Update Payment Plan Status";
        if (!returnResults.success) {  
            popAlert(returnResults.error?.error ?? ErrorReturnMessage.updateStatus,messageTitle,ModalStyles.danger);
            return false;
        } 
        if (returnResults.success.errorCode !== 0) { 
            popAlert(returnResults.success.errorMessage,messageTitle,ModalStyles.danger);
            return false;
        }
        return true;        
    }
    async function execUpdatePlanClaims() : Promise<boolean> {
        let claim_list : IClaim[] = [];
        if (formData.modelDisplay.addClaim) {
            if (!formData.selectedPatientClaims) {
                return false;
            } 
            claim_list = formData.selectedPatientClaims;
        } 
        else if (formData.modelDisplay.removeClaim) {
            if (!formData.selectedIncludedClaims) {
                return false;
            }
            claim_list = formData.selectedIncludedClaims; 
        }
        const total_adjustment_amount = (formData.claimAddRemoveData.canAdjustTotal && formData.claimAddRemoveData.adjustTotal ? formData.claimAddRemoveData.adjustmentAmount : 0);
        const claim_update_information : IPaymentPlanClaimUpdates = {paymentPlanId: props.paymentPlanId, addClaims: formData.claimAddRemoveData.addClaim, totalAdjustmentAmount: total_adjustment_amount, claimList: claim_list};
        const returnResults = await updatePaymentPlanClaims(claim_update_information);
        const messageTitle = "Update Payment Plan Claims";
        if (!returnResults.success) {  
            popAlert(returnResults.error?.error ?? ErrorReturnMessage.updateClaims,messageTitle,ModalStyles.danger);
            return false;
        } 
        if (returnResults.success.errorCode !== 0) { 
            popAlert(returnResults.success.errorMessage,messageTitle,ModalStyles.danger);
            return false;
        }
        return true;
    }
    async function execChangeRP() : Promise<boolean> {
        if (!formData.responsiblePartyEID) {
            return false;
        }
        const respPartyUpdate : IRespPartyUpdate = {paymentPlanId: props.paymentPlanId, responsiblePartyEID: formData.responsiblePartyEID};
        const returnResults = await changeRP(respPartyUpdate);
        const messageTitle = "Change Responsible Party";
        if (!returnResults.success) {  
            popAlert(returnResults.error?.error ?? ErrorReturnMessage.changeRP,messageTitle,ModalStyles.danger);
            return false;
        } 
        if (returnResults.success.errorCode !== 0) { 
            popAlert(returnResults.success.errorMessage,messageTitle,ModalStyles.danger);
            return false;
        }      
        return true;   
    }
    async function execDeferPlan() : Promise<boolean> {
        if (!formData.defermentPlan) {
            return false;
        }
        const returnResults = await deferPaymentPlan(formData.defermentPlan);
        const messageTitle = "Defer Payment Plan";
        if (!returnResults.success) {  
            popAlert(returnResults.error?.error ?? ErrorReturnMessage.defer,messageTitle,ModalStyles.danger);
            return false;
        } 
        if (returnResults.success.errorCode !== 0) { 
            popAlert(returnResults.success.errorMessage,messageTitle,ModalStyles.danger);
            return false;
        }
        return true;   
    }
    async function ModalSaveResponse() : Promise<void> {
        let save_result : boolean = false;
        if (formData.modelDisplay.updatePlan) { 
            save_result = await execUpdatePlan();
        }
        else if (formData.modelDisplay.updateStatus) {
            save_result = await execUpdatePlanStatus();
        }
        else if ((formData.modelDisplay.addClaim) || (formData.modelDisplay.removeClaim)) {
            save_result = await execUpdatePlanClaims();
        } 
        else if (formData.modelDisplay.defer) {
            save_result = await execDeferPlan();
        }
        else if (formData.modelDisplay.changeRespParty) {
            save_result = await execChangeRP();
        }
        if (save_result) {
            await refreshData();
            ModalHiddenResponse()
        }
    } 
    function validateInstallmentCount() : void {
        if (formData.priorValues.totalInstallments === formData.paymentPlanUpdate.totalInstallments) {
            return;
        }
        formData.paymentPlanUpdate.installmentAmount = formData.paymentPlanUpdate.totalAmount / formData.paymentPlanUpdate.totalInstallments;
        SetPriorValues();
    }
    function validatePlanInstallment() : void { 
        if (formData.priorValues.installmentAmount === formData.paymentPlanUpdate.installmentAmount) {
            return;
        }        
        formData.paymentPlanUpdate.totalInstallments = Math.ceil(formData.paymentPlanUpdate.totalAmount / formData.paymentPlanUpdate.installmentAmount);
        SetPriorValues();
    }
    function validatePlanTotal() : void { 
        formData.paymentPlanUpdate.totalInstallments = Math.ceil(formData.paymentPlanUpdate.totalAmount / formData.paymentPlanUpdate.installmentAmount);
        SetPriorValues();
    }
    function validateAdjTotal() : void {
        if (!formData.planDetails) {
            return;
        }
        formData.paymentPlanUpdate.totalAmount = formData.planDetails.totalAmount - formData.paymentPlanUpdate.writeOffAdjustmentAmount;
        formData.paymentPlanUpdate.totalInstallments = Math.ceil(formData.paymentPlanUpdate.totalAmount / formData.paymentPlanUpdate.installmentAmount);
        SetPriorValues();
    }
    
    async function displayAudit() : Promise<void> {   
        if (!props.paymentPlanId) {  
            return;
        } 
        ModalWindowOpen({screenID: AppScreens.Logging, urlParmData: {ScreenName: "PaymentPlan.cshtml", LogType: "s", StatementId: props.paymentPlanId.toString()}, title: "Payment Plan Audit"}); 
    }
    async function displayCompanySettings() : Promise<void> { 
        ModalWindowOpen({screenID: AppScreens.PaymentPlanRules, urlParmData: {PARM: "pplan"}, vueModalOnly: true, callBack: refreshData}); 
    }
    function onChangeRespParty(selectedItem : any) : void {
        formData.responsiblePartyEID = selectedItem.value;
    }   
    async function onDisplayCreditCard(updateCreditCard: boolean, paymentMethodId: number, card_information: string) : Promise<void> {
        formData.modelDisplay.addCard = false;
        if (!formData.planDetails) {
            return;
        }
        if (updateCreditCard) {
            const prior_payment_method_id = formData.cardUpdate.paymentMethodID;
            const prior_credit_card = formData.cardUpdate.creditCard;
            
            formData.cardUpdate.paymentMethodID = paymentMethodId;
            formData.cardUpdate.creditCard = card_information;
            const messageTitle = "Update Credit Card"; 
            const returnResults = await updatePaymentPlanCreditCard(formData.cardUpdate); 
            if (!returnResults.success) {  
                formData.cardUpdate.paymentMethodID = prior_payment_method_id;
                formData.cardUpdate.creditCard = prior_credit_card;
                await popAlert(returnResults.error?.error ?? ErrorReturnMessage.cardUpdate,messageTitle,ModalStyles.danger);
                return;
            } 
            if (returnResults.success.errorCode !== 0) { 
                formData.cardUpdate.paymentMethodID = prior_payment_method_id;
                formData.cardUpdate.creditCard = prior_credit_card;
                await popAlert(returnResults.success.errorMessage,messageTitle,ModalStyles.danger);
                return;
            }
            formData.planDetails.cardOnFile = (formData.cardUpdate.paymentMethodID > 0);
            formData.cardToolTip = `Card on file: ${(formData.cardUpdate.paymentMethodID ?? 0 > 0 ? formData.cardUpdate.creditCard : "None")}`;
            
            await refreshData();
        }
        else {
            formData.refreshCards = formData.refreshCards + 1;
        }
    }
    async function onDisplayPrintPaymentPlan() : Promise<void> {
        formData.modelDisplay.printPaymentPlan = false;
    }
    function SetSendStatement(_send : boolean) : void {
        if (formData.paymentPlanUpdate.doNotSendStatement) {
            formData.paymentPlanUpdate.excludeClaimStatements = false;
        }        
    }
    function SetExcludeStatement(_excluded: boolean) : void { 
        if (formData.paymentPlanUpdate.excludeClaimStatements) {
            formData.paymentPlanUpdate.doNotSendStatement = false;
        }
    }
</script> 
 
<style scoped>
    @import url('../../../css/paymentPlanGrid.css');
</style>
<template>
    <div class="row">
        <div class="col-11 fw-bold text-isalus-primary">Payment Plan</div>
        <div class="col-1 text-end">
            <DropDownButton :display-style="ButtonDisplayStyle.Link" :buttonIcon="DropDownButtonIconType.Gear" >
                <DropDownButtonItem style="font-size: .75rem;" :data="PageActions.Audit" @click="displayAudit">Audit</DropDownButtonItem>
                <DropDownButtonItem style="font-size: .75rem;" :data="PageActions.CompanySettings" @click="displayCompanySettings">Company Settings</DropDownButtonItem>
                <DropDownButtonItem style="font-size: .75rem;" :data="PageActions.Refresh" @click="refreshData">Refresh</DropDownButtonItem> 
            </DropDownButton>
        </div>  
    </div>
    <div class="skinnyscroll pt-3">
        <div v-if="formData.planDetails">
            <ActionFoldingPanel 
                panelTitle="Payment Plan Details"
                actionTitle="Detail Actions"  
                :actionList="detailButtons"> 
                <template #body>  
                    <div class="skinnyscroll label-isalus-small" :style="{ 'width': (planDetailsWidth + 'rem')}">
                        <div class="grid-container-plan-details">
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Plan Information</div>
                            <div class="details-span-5 pt-2 pp-grid-border-top pp-grid-border-left pp-grid-border-right">
                                <span class="text-isalus-primary">ID: </span>{{props.paymentPlanId}}
                                <span class="text-isalus-primary">Initial: </span>{{prettyCurrency(formData.planDetails.initialTotalAmount)}}
                                <span class="text-isalus-primary">Writeoff: </span>{{prettyCurrency(formData.planDetails.writeOffAdjustmentAmount)}}
                                <span class="text-isalus-primary">Type: </span>{{formData.planDetails.installmentTypeDescription}}
                                <span class="text-isalus-primary">Created by: </span>{{formData.planDetails.createdBy}}
                            </div>

                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Patient Information</div>
                            <div class="details-span-5 pt-2 pp-grid-border-top pp-grid-border-left pp-grid-border-right">
                                <span class="text-isalus-primary">Chart: </span>{{formData.planDetails.patientID}}
                                <span class="text-isalus-primary">Name: </span>{{formData.planDetails.patientName}}
                                <span class="text-isalus-primary">DOB: </span>{{formData.planDetails.patientDOB ?? ""}} 
                                <span v-if="formData.planDetails.patientRHC" class="text-isalus-primary">RHC: </span>
                                <span class="text-danger" v-if="formData.planDetails.patientRHC">{{formData.planDetails.patientRHC}}</span>
                            </div>
                            
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Responsible Party</div>
                            <div class="details-span-5 pt-2 pp-grid-border-top pp-grid-border-left pp-grid-border-right">
                                <span class="text-isalus-primary">Sys ID: </span>{{formData.planDetails.responsiblePartyEID}}
                                <span class="text-isalus-primary">Name: </span>{{formData.planDetails.responsiblePartyName}}
                            </div>

                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Comment</div>
                            <div class="details-span-5 pt-2 pp-grid-border-top pp-grid-border-left pp-grid-border-right">
                                {{formData.planDetails.comment}}
                            </div>                            
                            
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Status</div>
                            <div :class="`value-details text-center pt-2 pp-grid-border-top pp-grid-border-left ${statusDisplayClass}`">
                                {{formData.planDetails.statusDescription}}
                            </div>
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Total</div>
                            <div class="value-details pt-2 text-end pp-grid-border-top pp-grid-border-left" 
                                :title="`Initial Amount: ${prettyCurrency(formData.planDetails.initialTotalAmount)}\r\nTotal: ${prettyCurrency(formData.planDetails.totalAmount)}\r\nWriteoff: ${prettyCurrency(formData.planDetails.writeOffAdjustmentAmount)}`">
                                {{prettyCurrency(formData.planDetails.totalAmount)}}
                            </div>
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Card on File</div>
                            <div class="value-details pt-2 text-center pp-grid-border-top pp-grid-border-left pp-grid-border-right" :title="formData.cardToolTip">
                                {{(formData.planDetails.cardOnFile ? "Yes" : "No")}} 
                            </div>
                            
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Installment Start Date</div>
                            <div class="value-details text-center pt-2 pp-grid-border-top pp-grid-border-left">
                                {{formData.planDetails?.startDate}}
                            </div>
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Paid</div>
                            <div class="value-details pt-2 text-end pp-grid-border-top pp-grid-border-left">
                                {{prettyCurrency(formData.planDetails.totalPayments)}}
                            </div>
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Recurring Payments</div>
                            <div class="value-details pt-2 text-center pp-grid-border-top pp-grid-border-left pp-grid-border-right">
                                {{(formData.planDetails.recurringPayments ? "Yes" : "No")}}
                            </div>
                            
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Installment End Date</div>
                            <div class="value-details text-center pt-2 pp-grid-border-top pp-grid-border-left">
                                {{formData.planDetails.endDate}}
                            </div> 
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Remaining ({{formData.planDetails.remainingInstallments}})</div>
                            <div class="value-details pt-2 text-end pp-grid-border-top pp-grid-border-left">
                                {{prettyCurrency(formData.planDetails.remainingTotal)}}
                            </div>
                            <div class="label-details pt-2 pp-grid-border-top pp-grid-border-left">Exclude Claims from Statement</div>
                            <div class="value-details pt-2 text-center pp-grid-border-top pp-grid-border-left pp-grid-border-right">
                                {{(formData.planDetails.excludeClaimStatements ? "Yes" : "No")}}
                            </div> 

                            <div class="label-details pt-2 pp-grid-border-bottom pp-grid-border-top pp-grid-border-left">Next Due Date</div>
                            <div class="value-details pt-2 text-center pp-grid-border-bottom pp-grid-border-top pp-grid-border-left">
                                {{formData.planDetails.dueDate}}
                            </div> 
                            <div class="label-details pt-2 pp-grid-border-bottom pp-grid-border-top pp-grid-border-left">Installment ({{formData.planDetails.totalInstallments}})</div>
                            <div class="value-details pt-2 text-end pp-grid-border-bottom pp-grid-border-top pp-grid-border-left ">
                                {{prettyCurrency(formData.planDetails.installmentAmount)}}
                            </div> 
                            <div class="label-details pt-2 pp-grid-border-bottom pp-grid-border-top pp-grid-border-left">Do Not Send A Statement</div>
                            <div class="value-details pt-2 text-center pp-grid-border-bottom pp-grid-border-top pp-grid-border-left pp-grid-border-right">
                                {{(formData.planDetails.doNotSendStatement ? "Yes" : "No")}}
                            </div>
                        </div>
                    </div>
                </template> 
            </ActionFoldingPanel> 
            <div v-if="(formData.planClaims?.length ?? 0) > 0">
                <ActionFoldingPanel 
                    :panelTitle="formData.includedClaimInformation.message"
                    actionTitle="Claim Actions"  
                    collapseClass="col-sm-6"  
                    expandClass="col-sm-6"  
                    :actionList="includedClaimButtons">
                    <template #body>
                        <ClaimList 
                            :saveEnabled="props.saveEnabled"
                            :selection="selectClaim"
                            :claimList = "formData.planClaims"
                            :display="ClaimDisplay.PaymentPlanIncluded"                 
                            :displayProcedures="false"
                            :displayPayments="false"
                            :displayComments="false"
                            @selectedItems:model-value="setIncludedClaims" 
                        /> 
                    </template> 
                </ActionFoldingPanel> 
            </div>     
            <div v-if="(formData.patientClaims?.length ?? 0) > 0">
                <ActionFoldingPanel 
                    :panelTitle="formData.patientClaimInformation.message"
                    actionTitle="Balance Actions"
                    collapseClass="col-sm-6"  
                    expandClass="col-sm-6"  
                    :actionList="patientClaimButtons">
                    <template #body>
                        <ClaimList 
                            :saveEnabled="props.saveEnabled"
                            :selection="selectClaim"
                            :claimList = "formData.patientClaims"
                            :display="ClaimDisplay.PaymentPlanDetails"                 
                            :displayProcedures="false"
                            :displayPayments="false"
                            :displayComments="false"
                            @selectedItems:model-value="setPatientClaims" 
                        /> 
                    </template> 
                </ActionFoldingPanel> 
            </div>  
            <ActionFoldingPanel panelTitle="Payment Plan Summary"> 
                <template #body>
                    <div class="skinnyscroll label-isalus-small" :style="{ 'width': (planDetailsWidth + 'rem')}">
                        <div class="grid-container-plan-payments">
                            <div class="text-center label-plan pp-grid-border-top pp-grid-border-bottom pp-grid-border-left">#</div>
                            <div class="text-center label-plan pp-grid-border-top pp-grid-border-bottom pp-grid-border-left">Installment Due Date</div>
                            <div class="text-center label-plan pp-grid-border-top pp-grid-border-bottom pp-grid-border-left">Installment Amount</div>
                            <div class="text-center label-plan pp-grid-border-top pp-grid-border-bottom pp-grid-border-left">Paid Amount</div>
                            <div class="text-center label-plan pp-grid-border-top pp-grid-border-bottom pp-grid-border-left pp-grid-border-right">Paid Dates</div>
                        </div>
                        <div class="grid-container-plan-payments" v-if="(formData.payments?.length ?? 0) > 0" v-for="(paymentRecord,index) in formData.payments">
                            <div class="text-center value-plan pp-grid-border-bottom pp-grid-border-left">{{paymentRecord.installmentID}}</div>
                            <div class="text-center value-plan pp-grid-border-bottom pp-grid-border-left">
                                {{paymentRecord.dueDate}}
                                <span class="text-danger" v-if="paymentRecord.dueDate === formData.planDetails.dueDate">*</span>
                            </div>
                            <div class="text-end value-plan pp-grid-border-bottom pp-grid-border-left">{{prettyCurrency(paymentRecord.installmentAmount)}}</div>
                            <div class="text-end value-plan pp-grid-border-bottom pp-grid-border-left">{{prettyCurrency(paymentRecord.paymentAmount)}}</div>
                            <div class="value-plan pp-grid-border-bottom pp-grid-border-left pp-grid-border-right">{{paymentRecord.paymentDates}}</div>
                        </div>
                    </div>
                </template> 
            </ActionFoldingPanel>
            
            <div v-if="(formData.planDeferments?.length ?? 0) > 0">
                <ActionFoldingPanel panelTitle="Payment Deferment History"> 
                    <template #body> 
                        <div class="skinnyscroll label-isalus-small" :style="{ 'width': (planDetailsWidth + 'rem')}"> 
                            <div class="grid-container-deferment-history">
                                <div class="label-plan pp-grid-border-top pp-grid-border-bottom pp-grid-border-left pp-grid-border-right">Deferment Information</div>
                            </div>
                            <div class="grid-container-deferment-history"  v-for="(deferRecord,index) in formData.planDeferments">
                                <div class="value-plan pp-grid-border-bottom pp-grid-border-left pp-grid-border-right">{{deferRecord.defermentInformation}}</div> 
                            </div>
                        </div>
                    </template> 
                </ActionFoldingPanel> 
            </div>
        </div>   
    </div>
    <ModalDialog 
        :show="displayModalWindow"
        @hidden="ModalHiddenResponse"  
        :size="displayModalSize"
        :closeOnClickOutside=false>
        <template #title>
            <span v-if="formData.modelDisplay.updatePlan">Update Payment Plan</span>
            <span v-if="formData.modelDisplay.updateStatus">Payment Plan Status</span>
            <span v-if="formData.modelDisplay.defer">Defer Payment Plan</span>
            <span v-if="formData.modelDisplay.addClaim">Add Claims</span>
            <span v-if="formData.modelDisplay.removeClaim">Remove Claims</span>
            <span v-if="formData.modelDisplay.changeRespParty">Change Responsible Party</span>
        </template>
        <div v-if="formData.modelDisplay.updatePlan && formData.planDetails" class="grid-container-plan-updates label-isalus-small">  
            <div class="pt-2">Initial Amount</div>
            <div class="pt-2 pe-3 text-end">{{prettyCurrency(formData.planDetails.initialTotalAmount)}}</div>

            <div class="pt-2">Writeoff Adjustment</div>
            <div class="pt-2">
                <CurrencyInput
                    v-model:numberValue="formData.paymentPlanUpdate.writeOffAdjustmentAmount" 
                    :maxLength=10 
                    :startingRange=0
                    :endingRange="formData.planDetails.initialTotalAmount"
                    :positive=true
                    :required=false
                    :cssFramework = "'vanilla'"
                    @change:numberValue="() => validateAdjTotal()"
                    @validationState="(state, msg) => validateSection?.sinkValidation('Writeoff Adjustment', state, msg)" 
                />                    
            </div>
            
            <div class="pt-2">Total</div>
            <div class="pt-2">
                <CurrencyInput
                    v-model:numberValue="formData.paymentPlanUpdate.totalAmount" 
                    :maxLength=12 
                    :startingRange=formData.planSettings.MinimumAmt
                    :endingRange="planAbsoluteMaximum"
                    :positive=true
                    :required=true
                    :cssFramework = "'vanilla'"
                    @change:numberValue="() => validatePlanTotal()"
                    @validationState="(state, msg) => validateSection?.sinkValidation('Plan Total', state, msg)" 
                />
            </div>

            <div class="pt-2">Installment Amount</div>
            <div class="pt-2">
                <CurrencyInput
                    v-model:numberValue="formData.paymentPlanUpdate.installmentAmount" 
                    :maxLength=12 
                    :startingRange=0.01
                    :endingRange="formData.paymentPlanUpdate.totalAmount"
                    :positive=true  
                    :cssFramework = "'vanilla'"
                    @change:numberValue="() => validatePlanInstallment()"
                    @validationState="(state, msg) => validateSection?.sinkValidation('Installment Amount', state, msg)" 
                />                    
            </div>

            <div class="pt-2">Number of Installments</div>
            <div class="pt-2">
                <IntegerInput 
                    v-model:numberValue="formData.paymentPlanUpdate.totalInstallments"  
                    :maxLength=4 
                    :startingRange="formData.planSettings.MinimumCnt"
                    :endingRange="maximumInstallments"
                    :positive=true
                    LeftAddon="fa-solid fa-hashtag"
                    :cssFramework = "'vanilla'" 
                    @change:numberValue="() => validateInstallmentCount()"
                    @validationState="(state, msg) => validateSection?.sinkValidation('Number of Installments', state, msg)" 
                />                    
            </div>

            <div class="details-span-2 pt-2">Comments</div>
            <div class="details-span-2 pt-2">
                <TextInput 
                    :rows=2
                    v-model:textValue="formData.paymentPlanUpdate.comment" 
                    :cssFramework="'vanilla'"  
                />             
            </div> 
            <div class="details-span-2 pt-2">
                <Checkbox v-model="formData.paymentPlanUpdate.recurringPayments" :disabled="recurringDisabled" :title="'Recurring payments'"/>  
                <span label :class="recurringClass">Recurring payments</span>                    
            </div>             
            <div class="details-span-2 pt-2">           
                <Checkbox v-model="formData.paymentPlanUpdate.excludeClaimStatements" @update:modelValue="SetExcludeStatement"  :title="'Exclude claims from statements'"/>                            
                <span label class="ps-1 pe-3">Exclude claims from statements</span>               
            </div>     
            <div class="details-span-2 pt-2">      
                <Checkbox v-model="formData.paymentPlanUpdate.doNotSendStatement" @update:modelValue="SetSendStatement"  :title="'Do not send statement'"/>                            
                <span label class="ps-1">Do not send statement</span> 
            </div>
            <div class="details-span-2 pt-2">    
                <Validator ref="validateSection" @is-valid="state => formData.planUpdatesAreValid = state">
                    <template></template>
                </Validator>
            </div>
        </div>
        <div v-if="formData.modelDisplay.updateStatus">
            <div class="text-isalus-primary label-isalus-small pb-2">Select a new status from the list below:</div>
            <RadioButtonInput 
                :value="PlanStatus.Active" 
                :disabled="formData.disableStatus.Active"
                v-model="formData.paymentPlanStatusUpdate.statusID" 
                :layout="LayoutOrientation.Vert">  
                <div class="label-isalus-small">Active</div>
            </RadioButtonInput>
            <RadioButtonInput 
                :value="PlanStatus.Cancelled" 
                :disabled="formData.disableStatus.Cancelled"
                v-model="formData.paymentPlanStatusUpdate.statusID" 
                :layout="LayoutOrientation.Vert">  
                <div class="label-isalus-small">Cancelled</div>
            </RadioButtonInput>
            <RadioButtonInput 
                :value="PlanStatus.Completed" 
                :disabled="formData.disableStatus.Completed"
                v-model="formData.paymentPlanStatusUpdate.statusID" 
                :layout="LayoutOrientation.Vert">  
                <div class="label-isalus-small">Completed</div>
            </RadioButtonInput>
            <RadioButtonInput 
                :value="PlanStatus.Hold" 
                :disabled="formData.disableStatus.Hold"
                v-model="formData.paymentPlanStatusUpdate.statusID" 
                :layout="LayoutOrientation.Vert">  
                <div class="label-isalus-small">On Hold</div>
            </RadioButtonInput>
            <RadioButtonInput 
                :value="PlanStatus.PastDue" 
                :disabled="formData.disableStatus.PastDue"
                v-model="formData.paymentPlanStatusUpdate.statusID" 
                :layout="LayoutOrientation.Vert">  
                <div class="label-isalus-small">Past Due</div>
            </RadioButtonInput>
            <div class="details-span-2 pt-3">           
                <Checkbox v-model="formData.paymentPlanStatusUpdate.removeClaims" :disabled="formData.paymentPlanStatusUpdate.statusID != PlanStatus.Cancelled" :title="'Remove unused claims from payment plan.'"/>                            
                <span label class="label-isalus-small ps-1 pe-3">Remove unused claims from plan.</span>               
            </div>    
        </div>
        <div v-if="formData.modelDisplay.defer">
            <div class="text-isalus-primary label-isalus-small">Select a new deferment date from the list below.</div>
            <div class="text-isalus-primary label-isalus-small pb-2">Note: Any deferments already in existance will be removed.</div>
           
            <div class="row label-isalus-small">
                <div class="col-6">
                    <span class="pb-2 pt-2 pe-2">Deferment Date:</span>
                </div>
                <div class="col-6" v-if="formData.defermentPlan">
                    <select v-model="formData.defermentPlan.deferDate" class="form-select">
                        <option v-for="(deferRecord,index) in formData.defermentList" :value="deferRecord.deferDate">{{deferRecord.deferDate}}</option>
                    </select>
                </div>
            </div>

            <div class="text-isalus-primary label-isalus-small pt-3 pb-2">Additional periods can be added to the deferment list by modifing the value below.</div>
           
            <div v-if="formData.defermentPlan" class="row label-isalus-small pb-2">
                <div class="col-6">
                    <span class="pt-3">Additional Periods:</span>
                </div>  
                <div class="col-6">
                    <IntegerInput 
                        v-model:numberValue="formData.defermentPlan.numberOfPeriods"  
                        :maxLength=4 
                        :startingRange="0"
                        :endingRange="24"
                        :positive=true
                        LeftAddon="fa-solid fa-hashtag"
                        :cssFramework = "'vanilla'" 
                    />
                </div>  
            </div>
        </div> 
        <div v-if="formData.modelDisplay.addClaim">
            <div class="text-isalus-primary label-isalus-small pb-2">Do you wish to add the following claim(s): {{formData.claimAddRemoveData.claimList}} to the current plan?</div>
            <Checkbox v-model="formData.claimAddRemoveData.adjustTotal"/>  
            <span label class="ps-1 pe-3 label-isalus-small">Increase Plan Total from {{prettyCurrency(formData.planDetails?.totalAmount ?? 0)}} by {{prettyCurrency(formData.claimAddRemoveData.adjustmentAmount)}} to {{prettyCurrency((formData.planDetails?.totalAmount ?? 0) + formData.claimAddRemoveData.adjustmentAmount)}} </span>        
        </div> 
        <div v-if="formData.modelDisplay.removeClaim">
            <div class="text-isalus-primary label-isalus-small pb-2">Do you wish to remove the following claim(s): {{formData.claimAddRemoveData.claimList}} from the current plan?</div>
            <Checkbox v-model="formData.claimAddRemoveData.adjustTotal" :disabled="!formData.claimAddRemoveData.canAdjustTotal"/>  
            <span label class="ps-1 pe-3 label-isalus-small">Reduce Plan Total from {{prettyCurrency(formData.planDetails?.totalAmount ?? 0)}} by {{prettyCurrency(formData.claimAddRemoveData.adjustmentAmount)}} to {{prettyCurrency((formData.planDetails?.totalAmount ?? 0) - formData.claimAddRemoveData.adjustmentAmount)}} </span>        
        </div>
        <div v-if="formData.modelDisplay.changeRespParty"> 
            <SimpleList v-if="respPartyListLoaded"
                :listName="ClaimSimpleLists.RespParty"
                :includeHeader="true"
                :includeBlank="false" 
                v-model:selected="formData.responsiblePartyEID"
                @onChange="onChangeRespParty" 
            />
        </div>
        <template #footer> 
            <ActionButtonV2 
                :action="ActionButtonStyle.Save"
                :disabled="!formData.planUpdatesAreValid"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary" 
                :spinText="'Saving'"
                :performAction="ModalSaveResponse"
                :endingPadding="1"
            /> 
            <ActionButtonV2 
                :action="ActionButtonStyle.Close"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary" 
                :spinText="'Closing'"
                :performAction="ModalHiddenResponse"
            /> 
        </template>
    </ModalDialog>
    <div v-if="formData.modelDisplay.addCard">
        <PaymentPlanCreditCard
            :show="true"
            :patientId="formData.planDetails?.patientID"
            :patientName="formData.planDetails?.patientName"
            :paymentMethodId="formData.cardUpdate.paymentMethodID"
            :refreshCards="formData.refreshCards"
            @onDisplay="onDisplayCreditCard" 
        />
    </div>
    <div v-if="formData.modelDisplay.printPaymentPlan">
        <PaymentPlanPrint
            :show="true"
            :paymentPlanId="props.paymentPlanId"
            @onDisplay="onDisplayPrintPaymentPlan" 
        />
    </div>
</template>
